module.exports = __webpack_public_path__ + "static/media/Montreal_Canadiens.1cbe8f12.svg";